import { render, staticRenderFns } from "./productSelectDialog.vue?vue&type=template&id=91df4618&scoped=true"
import script from "./productSelectDialog.vue?vue&type=script&lang=js"
export * from "./productSelectDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91df4618",
  null
  
)

export default component.exports